export enum MemberLookupMethod {
  MembershipNumber = "MembershipNumber",
  MembershipCardNumber = "MembershipCard Number",
  MembershipBadgeNumber = "MembershipBadgeNumber",
}

export const MemberLookupMethodList = () =>
  Object.entries(MemberLookupMethod).map(([label, value]) => {
    return { label, value };
  });
